export default {
  pageOptions: (state, options) => {
    state.options = options;
  },
  setInhabitantChangeStatuses: (state, statuses) => {
    state.inhabitantChangeStatuses = statuses;
  },
};
